import { render } from "./UsersStats.vue?vue&type=template&id=212cd231&scoped=true"
import script from "./UsersStats.vue?vue&type=script&lang=js"
export * from "./UsersStats.vue?vue&type=script&lang=js"

import "./UsersStats.vue?vue&type=style&index=0&id=212cd231&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212cd231"]])

export default __exports__